export default __webpack_public_path__ + "static/media/Girdle of Illuminant Conviction.2b895dc8.jpg";